<template>
  <div class="useCarApplyContainer">
    <div class="useCarApplyContent">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="carInfo.applyTitle" name="1">
          <van-cell-group v-if="carInfo.leaderCode">
            <van-field v-model="carInfo.leaderCode" label="工号" placeholder="请输入工号" :rules="[{ required: true }]"
              readonly />
          </van-cell-group>
          <van-cell-group v-if="carInfo.leaderCode">
            <van-field v-model="carInfo.leaderName" label="姓名" placeholder="姓名" readonly />
          </van-cell-group>
          <van-cell-group v-if="carInfo.leaderCode">
            <div>{{ carInfo.deptName }}</div>
            <van-field v-model="carInfo.deptName" label="部门" placeholder="部门" readonly />
          </van-cell-group>

          <van-cell-group>
            <div class="typeContainer">
              <div class="labelTitle">用车类型</div>
              <div class="useCarType">
                <div class="typeItems" :class="carInfo.useType === (index + 1) ? 'typeItemsActive' : ''"
                  v-for="(item, index) in columns" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.useCost" label="用车成本中心" readonly />
            <div class="hintContent">
              <span>*</span>
              注意：用车的成本中心号需要填写惠州雷士光电科技的成本中心号
            </div>
          </van-cell-group>
          <van-cell-group v-if="carInfo.useType === 2">
            <van-field v-model="carInfo.flightInfo" label="航班信息" readonly />
          </van-cell-group>
          <van-cell-group v-if="carInfo.useType == 2">
            <van-field readonly v-model="carInfo.expectArrivalTime" label="预计送达时间" />
          </van-cell-group>
          <van-cell-group>
            <van-field readonly v-model="carInfo.useSaterTime" label="预估开始使用时间" />
          </van-cell-group>
          <van-cell-group>
            <van-field readonly v-model="carInfo.useEndTime" label="预估结束使用时间" />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.airportName"
              :label="carInfo.useType == 2 ? '起点' : carInfo.useType == 3 ? '起点' : '起点'" class="my-field" readonly>
              <template #button>
                <i style="font-size: 24px; color: #4ea27c" class="iconfont icon-mapmarker"></i>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.addressInfoList" label="终点" readonly class="my-field">
              <template #button>
                <i style="font-size: 24px; color: #4ea27c" class="iconfont icon-mapmarker"></i>
              </template>
            </van-field>
          </van-cell-group>
          <!-- <van-cell-group>
            <van-field v-model="carInfo.destination" label="终点" readonly class="endPlace">
              <template #button>
                <i style="font-size: 24px; color: #4ea27c" class="iconfont icon-mapmarker"></i>
              </template>
            </van-field>
          </van-cell-group> -->
          <van-cell-group>
            <van-field
              v-model="carInfo.reason"
              rows="3"
              autosize
              label="用车事由"
              type="textarea"
              placeholder="请输入用车事由"
              readonly
            />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.useNumber" label="用车人数" readonly>
              <template #button>
                <van-icon name="arrow-down" />
              </template>
            </van-field>

          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.useName" label="联系人" readonly />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.usePhone" label="联系人电话" readonly>
              <template #button>
                <a :href="'tel:' + carInfo.usePhone" style="color: #4ea27c">
                  <i style="font-size: 0.6rem;" class="iconfont icon-telephone"></i>
                </a>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.remarks" rows="3" autosize label="备注（随车物品）" type="textarea" readonly />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="公务车信息" name="2">
          <van-cell-group>
            <van-field v-model="carInfo.carBrand" label="车牌" readonly />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.driverName" label="司机姓名" readonly />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.driverPhone" label="联系方式" readonly>
              <template #button v-if="carInfo.driverPhone">
                <a :href="'tel:' + carInfo.usePhone" style="color: #4ea27c">
                  <i style="font-size: 0.6rem;" class="iconfont icon-telephone"></i>
                </a>
              </template>
            </van-field>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
      <van-cell-group style="padding:10px 20px" v-show="carInfo.approveList.length > 0">
        <div class="flowPath">
          <div class="flowPathTitle">审批流</div>
          <div class="container_item">
            <div>
              <div class="handle" v-for="(approve,index) in carInfo.approveList" :key="approve.id">
                <div class="handleDiv">
                  <img src="@/assets/car/handle.png" alt="" srcset="" style="width: 27px; height: 27px" />
                </div>
                <div class="handleRight">
                  <h3 class="rightTitle" v-if="approve.nodeName">{{ approve.nodeName }}</h3>
                  <h3 class="rightTitle" v-if="!approve.nodeName">
                    {{ index == 0 ? "直属上级审批" : "审批人" }}
                    <!-- {{ approve.nodeName }} -->
                  </h3>
                  <div class="approver">
                    <div class="approverImg">
                      <span class="clr-span">{{ approve.approveName }}</span>
                    </div>
                    <div class="right">
                      <span style="margin-right: 5px"
                        :style="{ color: (approve.approveState == '通过' ? '#267ef0' : approve.approveState == '驳回' ? 'red' : '') }"
                        v-if="approve.nodeName">{{
                          approve.approveState }}</span>
                      <span style="margin-right: 5px"
                        :style="{ color: (approve.approveState == '2' ? '#267ef0' : approve.approveState == '3' ? 'red' : '') }"
                        v-if="!approve.nodeName">

                        {{ approve.approveState == '2' ? '已同意' : approve.approveState == '3' ? '已拒绝' : '' }}
                        <!-- {{ approve.approveState }} -->
                      </span>
                      <span>{{ approve.approveTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car";
import moment from "moment";
import "moment/locale/zh-cn";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "CarDetails",
  data() {
    return {
      activeNames: ["1","2"],
      carInfo: {
        useType: '',
        applyTitle: '', //申请标题
        useTypeValue: "",
        useCost: "",
        flightInfo: "",
        expectArrivalTime: "",
        useSaterTime: "",
        useEndTime: "",
        airportName: "",
        destination: "",
        useNumber: "",
        useName: "",
        usePhone: "",
        remarks: "",
        carBrand: "",
        driverName: "",
        applyState: '',
        realityMileage: '',
        travelCost: '',
        useState: '',
        addressInfoList: '',
        driverPhone: '',
        approveList: [],
        leaderCode: null,//领导工号
        leaderName: '',//领导姓名
        deptName: "",//领导部门
        reason:'', //用车事由
      },
      columns: ["客户接待", "接机", '送机', "供应商考察", "其他"],
    };
  },
  mounted() {
    this.queryCarDetailInfo();
  },
  methods: {
    // 获取用车详情
    queryCarDetailInfo() {
      apis.queryUseCarDetails({ applyNumber: this.$route.query.applyNumber }).then(res => {
        if (res.code === 200) {
          this.$nextTick(() => {
            this.carInfo = res.data;
            this.carInfo.expectArrivalTime = res.data.expectArrivalTime ? moment(res.data.expectArrivalTime).format("YY年MM月DD日 dddd HH:mm") : '';
            this.carInfo.useEndTime = res.data.useEndTime ? moment(res.data.useEndTime).format("YY年MM月DD日 dddd HH:mm") : '';
            this.carInfo.useSaterTime = res.data.useSaterTime ? moment(res.data.useSaterTime).format("YY年MM月DD日 dddd HH:mm") : '';
            // this.carInfo.addressInfoList = res.data.addressInfoList.map(item => item.useLocation).toString()
            if (res.data.addressInfoList.length > 0) {
              // res.data.addressInfoList.shift();
              // res.data.addressInfoList.pop();
              this.carInfo.addressInfoList = (res.data.addressInfoList).map(item => item.useLocation).toString();
            } else {
              this.carInfo.addressInfoList = '';
            }
            this.carInfo.deptName = res.data.applyDeptName;
          });

        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .useCarApplyContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .useCarApplyContainer {
    width: 276px * $zoom;
  }
}

.useCarApplyContainer {
  width: 100%;
  display: flex;
  justify-content: center;

  .useCarApplyContent {
    // width: 23.4375rem;
    width: 100%;

    ::v-deep .van-cell__title {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #282b32;
    }

    ::v-deep(.van-cell-group) {
      .van-cell {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
      }

      .van-field__value {
        background-color: #f7f9fa;
        padding: 10px 20px;
      }

      .van-cell::after {
        content: "";
        border-bottom: 0;
      }

      .van-field__label {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
      }

      .van-field__label {
        width: 500px !important;
      }

      .endPlace .van-field__label::after {
        content: "（默认为公司，有需要可修改）";
        font-size: 16px;
        color: #b5b9bb;
      }
    }

    ::v-deep .van-hairline--top-bottom::after {
      content: "";
      border: 0;
    }

    .typeContainer {
      padding: 18px 0;

      .labelTitle {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
      }

      .useCarType {
        display: flex;
        margin-top: 10px;

        .typeItems {
          padding: 0 10px;
          // width: 160px;
          height: 54px;
          line-height: 54px;
          text-align: center;
          background: #f7f9fa;
          border-radius: 4px;
          margin-right: 20px;
          color: #969b9e;
        }

        .typeItemsActive {
          background-color: #4ea27c;
          color: #fff;
        }
      }
    }

    .userName {
      font-size: 26px;
      padding: 20px 25px;
    }

    .hintContent {
      font-size: 18px;
      padding-bottom: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #969b9e;

      span {
        color: red;
      }
    }

    .flowPath {
      padding: 15px 0;

      .flowPathTitle {
        margin-bottom: 20px;
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
      }
    }

    .handle {
      display: flex;

      .handle-div::after {
        display: block;
        content: "";
        width: 1px;
        height: 70px;
        background-color: #ccc;
        position: relative;
        left: 24px;
      }

      .handle-div {
        position: relative;
      }
    }

    .copy {
      display: flex;

      .copy-div {
        position: relative;
      }
    }

    .clr-span {
      display: inline-block;
      width: 160px;
      border-radius: 20px;
      background-color: rgb(248 250 251);
      margin: 0 5px;
      padding: 10px 0;
      font-size: 32px;
      text-align: center;
    }
  }

  .container_item {
    background: #fff;
    margin-top: 20px;
    padding: 25px;

    .title {
      color: rgba(150, 155, 158, 1);
      font-size: 30px;
    }

    .handle {
      display: flex;
      margin-top: 10px;

      &:last-child {
        .handleDiv::after {
          width: 0;
          height: 0;
        }
      }

      .handleDiv::after {
        display: block;
        content: "";
        width: 1px;
        height: 70px;
        background-color: #ccc;
        position: relative;
        left: 24px;
      }

      .handleRight {
        margin-left: 20px;
        width: calc(100vh);

        .rightTitle {
          margin: 10px 0;
          font-size: 29px;
        }

        .approver {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;

          .approverImg {
            display: flex;
            flex-shrink: 0;
            align-items: center;

            .iconWrapper {
              position: relative;

              .elIcon {
                position: absolute;
                left: 40px;
                top: -10px;
                font-size: 22px;
              }
            }

            .clr-span {
              display: inline-block;
              border-radius: 20px;
              background-color: rgb(248 250 251);
              margin: 0 5px;
              padding: 10px 0;
              font-size: 24px;
              text-align: center;
              margin-left: 15px;
            }
          }

          .right {
            flex-shrink: 0;
            // margin-left: 30%;
            font-size: 22px;
            color: #9fa2a5;
          }
        }
      }
    }
  }
}</style>
